
import { Reducer } from 'redux';
import { ACTION, RequestExecuteFavourite, ReceiveExecuteFavourite, FailExecuteFavourite } from './action-types';
import * as actions from './action-types';
import { ChartState } from './types-store';

export const INITIAL_STATE: ChartState = {
  favouriteValid: true,

  layoutTypes: undefined,
  selectionReport: undefined,
  selectionReportLayout: undefined,
  fetchingExecute: false,
  executeRequestId: 0,
  executeFailed: false,
  errorsExecuteFailed: undefined,
  fetchingOptionsDrillDownTo: false,
  optionsDrillDownTo: undefined
};

export const chartReducers: { [indexer: string]: Reducer<ChartState> } = {
  //#region General
  [ACTION.CLEAR_SELECTION_REPORT_STATE]: (state: ChartState,
    action: actions.ClearSelectionReportState
  ): ChartState => {
    return {
      ...state,
      ...INITIAL_STATE
    };
  },
  [ACTION.REQUEST_LAYOUT_TYPES]: (state: ChartState,
    action: actions.RequestLayoutTypes
  ): ChartState => {
    return {
      ...state
    };
  },
  [ACTION.RESPONSE_LAYOUT_TYPES]: (state: ChartState,
    action: actions.ResponseLayoutTypes
  ): ChartState => {
    return {
      ...state,
      layoutTypes: action.data
    };
  },
  [ACTION.FAVOURITE_NOT_VALID]: (state: ChartState,
    action: actions.FavouriteNotValid
  ): ChartState => {
    return {
      ...state,
      favouriteValid: false,
      fetchingExecute: false,
      selectionReport: undefined
    };
  },
  /**
   * Run when starting fetching data for a case report favourite.
   */
  [ACTION.REQUEST_EXECUTE_FAVOURITE]: (state: ChartState,
    action: RequestExecuteFavourite): ChartState => {

    return {
      ...state,
      favouriteValid: true,
      executeFailed: false,
      selectionReport: undefined,
      selectionReportLayout: undefined,
      fetchingExecute: true,
      executeRequestId: state.executeRequestId + 1
    };
  },

  /**
   * Run when finished fetching data for case report favourite.
   */
  [ACTION.RESPONSE_EXECUTE_FAVOURITE]: (state: ChartState,
    action: ReceiveExecuteFavourite): ChartState => {

    if (action.requestId === state.executeRequestId) {
      return {
        ...state,
        fetchingExecute: false,
        executeFailed: false,
        selectionReport: action.data,
        selectionReportLayout: action.layout,
        errorsExecuteFailed: undefined
      };
    }
    return state;
  },

  [ACTION.FAIL_EXECUTE_FAVOURITE]: (state: ChartState,
    action: FailExecuteFavourite): ChartState => {

    return {
      ...state,
      fetchingExecute: false,
      executeFailed: true,
      selectionReport: undefined,
      selectionReportLayout: undefined,
      errorsExecuteFailed: action.errorsExecuteFailed      
    };
  },

  [ACTION.REQUEST_OPTIONS_DRILL_DOWN_TO]: (state: ChartState,
    action: actions.RequestOptionsDrillDownTo
  ): ChartState => {
    return {
      ...state,
      fetchingOptionsDrillDownTo: true
    };
  },
  
  [ACTION.RESPONSE_OPTIONS_DRILL_DOWN_TO]: (state: ChartState,
    action: actions.ResponseOptionsDrillDownTo
  ): ChartState => {
    return {
      ...state,
      fetchingOptionsDrillDownTo: false,
      optionsDrillDownTo: action.data
    };
  }
  //#endregion
};

export const chartReducer: Reducer<ChartState> = (state: ChartState = INITIAL_STATE, action: any) => {
  const r = chartReducers[action.type];
  return (r && r(state, action)) || state;
};
